import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function FAQAccordion({ items, className }) {
  const [open, setOpen] = useState(0);
  return (
    <div className={cn('mx-auto max-w-3xl divide-y divide-slate-200 overflow-hidden rounded-2xl border border-slate-200 bg-white dark:divide-white/10 dark:border-white/10 dark:bg-white/[0.02]', className)}>
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={it.q}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6"
            >
              <span className="text-sm font-semibold text-slate-900 dark:text-white sm:text-base">{it.q}</span>
              <span className={cn('flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors', isOpen ? 'bg-brand text-white' : 'bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-slate-300')}>
                {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
              </span>
            </button>
            {isOpen && (
              <div className="px-5 pb-5 sm:px-6">
                <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-300">{it.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
